import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import header6 from "../assets/header6.jpg";
import { FaEarthOceania } from "react-icons/fa6";
import { MdMarkEmailUnread } from "react-icons/md";
import { IoMdPersonAdd } from "react-icons/io";
import { PiExportFill } from "react-icons/pi";

import TabMenu from "../components/TabMenu";
import SubscriptionPlansHome from "../components/SubscriptionPlansHome";
import FaqList from "../components/FaqList";
import ContactForm from "../components/ContactForm";
import ChatFAQ from "../components/ChatFAQ";
const Mind = () => {
  const features = [
    { icon: <FaEarthOceania />, text: "Disponible 100 % en ligne" },
    { icon: <IoMdPersonAdd />, text: "Invitation du comptable" },
    { icon: <MdMarkEmailUnread />, text: "Relances automatiques" },
    { icon: <PiExportFill />, text: "Export PDF illimité" },
  ];
  const handleScroll = () => {
    document.getElementById("contact")?.scrollIntoView({
      behavior: "smooth",
    });
  };
  return (
    <>
      <Navbar />
      {/* Premier div (contenu principal) */}
      <main className="flex flex-col gap-5 items-center w-full justify-between lg:pt-12 pt-5 ">
        {/*Header*/}
        <section
          className="
    bg-color1 pl-4 sm:pl-4 lg:pl-4 xl:pl-4 2xl:pl-24  
    pr-4 flex flex-col lg:flex-row 
    w-full justify-center gap-4 items-center 
    lg:pt-20 pt-20 pb-10 lg:min-h-screen 
    font-Poppins
  "
        >

          {/* Texte */}
          <div className="flex flex-col gap-5 lg:gap-9 lg:w-1/2 w-full items-start justify-center">
            {/* Main Title */}
            <div className="flex flex-col gap-2 text-start">
              <p className="font-semibold tracking-widest text-blue-400 text-lg sm:text-xl uppercase">
                AUTOMATISEZ VOTRE GESTION
              </p>

              <p className="font-bold text-color2 tracking-widest text-2xl sm:text-3xl md:text-5xl lg:text-6xl leading-snug lg:leading-[4.4rem]">
                Toute votre gestion freelance, réunie en un seul endroit.
              </p>
            </div>

            {/* Subtitle */}
            <p className="font-normal text-color2 tracking-widest text-base sm:text-lg lg:text-xl leading-relaxed text-start opacity-90">
              Créez vos devis et factures en quelques clics et relancez vos clients automatiquement.
            </p>


            {/* Bouton */}
            <button
              onClick={handleScroll}
              className="py-3 px-6 font-semibold text-base sm:text-lg lg:text-xl text-color2 
        rounded-full bg-color3 hover:bg-color3/90 shadow-md cursor-pointer transition"
            >
              Contactez-Nous
            </button>

          </div>

          {/* Image */}
          <div className="lg:w-1/2 w-full flex items-center justify-start">
            <img
              src={header6}
              alt="gestion freelance"
              className="w-full h-auto rounded-2xl max-h-[50vh] lg:max-h-[80vh] lg:max-w-[95%] object-contain"
            />
          </div>
        </section>


        {/* Sub Header */}

        {/*change service */}
        <TabMenu />
        {/* Sub Header */}
        <section className="flex flex-col items-center lg:py-14 py-6 gap-8 px-4 text-center w-full bg-color1" id="accompagner">
          <h1 className="font-bold font-Poppins text-color2
                text-2xl sm:text-2xl md:text-2xl lg:text-4xl text-center 
                leading-snug lg:leading-[4rem]">
            Facilitez vos démarches avec notre équipe de gestion
          </h1>

          <p className="font-Poppins font-normal tracking-widest text-base sm:text-md md:text-lg lg:text-xl leading-relaxed text-color2 lg:w-2/3 w-full">
            Pour seulement <span className="font-bold">29,90 €</span>, envoyez-nous votre Kbis et votre pièce d’identité. Notre service de gestion pourra, à votre demande, procéder à votre inscription et établir votre premier devis en fonction des informations fournies.
          </p>
          <div className="flex flex-row w-full flex-wrap items-center gap-4 sm:gap-6 justify-center">
            <button
              onClick={handleScroll}

              className="py-3 px-6 font-semibold text-base sm:text-lg lg:text-xl text-color2 
        rounded-full bg-color3 hover:bg-color3/90 shadow-md cursor-pointer transition"
            >
              Contactez-Nous
            </button>

          </div>

        </section>


        <SubscriptionPlansHome />
        {/*sub services*/}
        <section className="flex flex-col items-center lg:py-16 py-8 lg:gap-8 gap-4 px-1 text-center w-full bg-color1" >
          <h1 className="font-bold font-Poppins text-color2
                text-2xl sm:text-2xl md:text-2xl lg:text-4xl text-center 
                leading-snug lg:leading-[4rem]">
            Gérer vos devis et factures n’a jamais été aussi simple
          </h1>
          <div className="grid lg:grid-cols-4 grid-cols-2 gap-5 lg:w-2/3 w-full mx-auto text-center">
            {features.map((feature, index) => (
              <div key={index} className="flex flex-col items-center gap-2">
                {React.cloneElement(feature.icon, { size: 28, className: "text-color3" })}
                <p className="text-color2 font-Poppins text-sm lg:text-base">{feature.text}</p>
              </div>
            ))}
          </div>

        </section>
        <FaqList />
        <ContactForm />
      </main >
      <ChatFAQ />
      <Footer />
    </>
  );
};

export default Mind;
